<template>
	<v-footer app padless v-bind="localAttrs" id="footer_area" elevation="1" height="53px"
		:class="{ min: checkDisplayPcFromMobile }">
    <v-col class="ma-0 pa-2" cols="12">
			<v-row class="ma-0 pa-0" align="center" justify="center">
				<v-col class="ma-0 pa-0" cols="auto">{{'表示切替 :'}}</v-col>
				<v-btn 
					width="5rem" height="auto" class="ma-0 pa-2" 
					id="back_clean_btn" elevation="0" @click="switchMobileOrPC('pc')">
					{{'PC'}}
				</v-btn>
				<v-divider vertical id="middle_divider" class="ma-0 pa-0"></v-divider>
				<v-btn 
					width="7rem" height="auto" class="ma-0 pa-2 text-none" 
					id="back_clean_btn" elevation="0" @click="switchMobileOrPC('mobile')">
					{{'Mobile'}}
				</v-btn>
			</v-row>
    </v-col>
  </v-footer>
</template>

<script>
import mixin from '@/mixin';
import { isAndroid } from 'mobile-device-detect';
export default {
	mixins: [mixin.common],
	data: () => ({
		checkDisplayPcFromMobile: true,
  }),
	watch: {
		'$store.state.isPortrait': function(item) {
			console.log('isPortrait change', item);
			if(isAndroid) {
				if(this.$store.state.isMobile) {
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				} else {
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				}
			} else {
				this.checkDisplayPcFromMobile = true;
			}
		},
		'$store.state.isMobile': function(item) {
			console.log('isMobile change', item);
			if(isAndroid) {
				if(this.$store.state.isPortrait) {
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				} else { // 가로
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				}
			} else {
				this.checkDisplayPcFromMobile = true;
			}
		}
	},
	computed: {
    localAttrs () {
      const attrs = {}
			attrs['absolute'] = true
      return attrs
    },
  },
  created() {
    if(isAndroid) {
			if(window.location.href.includes('mobile')) {
				this.checkDisplayPcFromMobile = false;
			} else {
				this.checkDisplayPcFromMobile = true;
			}
		}
  },
  methods: {
    switchMobileOrPC(view) {
			const authorities = this.$store.getters.getAuthorities;
			const role = this.$store.getters.getRole;
			const checkRole = this.roleCheck(role);
			if(view == 'pc') {
				this.$store.state.isMobile = false;
				// this.$store.commit('setDeviceEnvironment', { value: 'pc', time: Date.now() });
				if(checkRole == 'main' || checkRole == 'head') {
					if(authorities.GET_DASHBOARD) this.pushRoute('/dashboard', {});
					else this.pushRoute('/notification', {});
				} else {
					if(authorities.GET_RECORDING) this.pushRoute('/private/store-cctv', {});
					else this.pushRoute('/private/notification', {});
				}
			} else { // mobile
				this.$store.state.isMobile = true;
				// this.$store.commit('setDeviceEnvironment', { value: 'mobile', time: Date.now() });
				if(checkRole == 'main' || checkRole == 'head') {
					this.pushRoute('/mobile-home', {});
				} else {
					this.pushRoute('/mobile-thumbnailview', {});
				}
			}
		}
  },
}
</script>

<style lang="scss" scoped>
#footer_area {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
  background-color: #363b48;
	color: white;
	font-weight: bold;
	z-index: 12;
}
#middle_divider {
	background-color: #fff;
}
/* @media ( max-width: 768px ) {
  #footer_area {
    display: none;
  }
} */
</style>